<template>
  <div class="workshop cardover" @click="GotoWS(workshop.id)">
    <div class="workshop__author-pic">
      <u-live-icon v-if="workshop.category.includes('live')"></u-live-icon>
      <img :src="`https://backend.upskill.com.bd${workshop.image}`" />
    </div>
    <div class="workshop__info">
      <p class="workshop__info-date">{{ getTime(workshop.workshop_ts) }}</p>
      <h3 class="workshop__info-title">{{ workshop.name }}</h3>
      <p class="workshop__info-speaker">
        {{ workshop.location.slice(0, 40) }}...
      </p>
    </div>
    <div class="workshop__action">
      <div class="workshop__action-info">
        <span>{{ workshop.fee === 0 ? 'Free' : `Tk.${workshop.fee}` }}</span>
        <span>{{ getTimeLeft(workshop.workshop_ts) }}</span>
      </div>
      <div class="workshop__action-register">
        <a class="btn btn-success">View Workshop</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['workshop'],
  methods: {
    getTime(pwstime) {
      return moment(pwstime).format('ddd, DD MMMM, YYYY')
    },
    getTimeLeft(pwstime) {
      return moment(pwstime).fromNow()
    },
  },
}
</script>
